import type { PropertyAdAmenityField, PropertyAdAmenityValues } from '../../types/propertyAdEditor';

interface PropertyAdAmenityOption {
  field: PropertyAdAmenityField;
  label: string;
}

interface PropertyAdAmenityGroup {
  title: string;
  options: readonly PropertyAdAmenityOption[];
}

export const PROPERTY_AD_AMENITY_GROUPS = [
  {
    title: 'Shared amenities',
    options: [
      { field: 'sharedGym', label: 'Gym' },
      { field: 'sharedPool', label: 'Pool' },
      { field: 'sharedSpa', label: 'Spa' },
      { field: 'barbecueArea', label: 'Barbecue' },
      { field: 'publicParking', label: 'Public parking' },
      { field: 'childrenPlayArea', label: "Children's play area" },
      { field: 'coveredParking', label: 'Covered parking' },
      { field: 'tennisCourts', label: 'Tennis courts' },
    ],
  },
  {
    title: 'Apartment',
    options: [
      { field: 'balcony', label: 'Balcony' },
      { field: 'lobbyInBuilding', label: 'Lobby in building' },
      { field: 'maidsRoom', label: 'Maids room' },
      { field: 'study', label: 'Study' },
      { field: 'kitchenAppliances', label: 'Kitchen appliances' },
      { field: 'builtInWardrobes', label: 'Built in wardrobes' },
      { field: 'centralAc', label: 'Central A/C' },
    ],
  },
  {
    title: 'Services',
    options: [
      { field: 'concierge', label: 'Concierge' },
      { field: 'laundryFacility', label: 'Laundry facility' },
      { field: 'maidService', label: 'Maid service' },
      { field: 'petsAllowed', label: 'Pets allowed' },
      { field: 'petsNotAllowed', label: 'Pets not allowed' },
      { field: 'security', label: 'Security' },
    ],
  },
  {
    title: 'Private amenities',
    options: [
      { field: 'privateGarden', label: 'Private garden' },
      { field: 'privateGym', label: 'Private gym' },
      { field: 'privatePool', label: 'Private pool' },
      { field: 'privateSpa', label: 'Private spa' },
    ],
  },
] as const satisfies readonly PropertyAdAmenityGroup[];

export const PROPERTY_AD_AMENITY_FIELDS = PROPERTY_AD_AMENITY_GROUPS.flatMap((group) =>
  group.options.map((option) => option.field)
) as readonly PropertyAdAmenityField[];

export const getPropertyAdAmenityValues = (
  values: Partial<Record<PropertyAdAmenityField, boolean | null | undefined>>
): PropertyAdAmenityValues =>
  PROPERTY_AD_AMENITY_FIELDS.reduce<PropertyAdAmenityValues>((amenities, field) => {
    amenities[field] = values[field] ?? false;
    return amenities;
  }, {} as PropertyAdAmenityValues);

export const EMPTY_PROPERTY_AD_AMENITY_VALUES = getPropertyAdAmenityValues({});
